export const CAP_ONE_LOGO_ALT = "Capital One Travel";
export const CAP_ONE_CORP_LOGO_ALT = "Capital One Business Travel";
